import { useCallback, useMemo, useState } from "react";
import {
  Table,
  ScrollArea,
  Group,
  Text,
  ActionIcon,
  Switch,
  TextInput,
  Badge,
} from "@mantine/core";
import { Check, Edit, Eye, Trash } from "tabler-icons-react";
import { sortData } from "../../../utils/tableActions";
import Th from "../../../components/Th";
import { useNavigate } from "react-router-dom";
import { useEditEpreuvesMutation } from "../../../redux/features/epreuveApi";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";

export default function EpreuveTable({ data, handleArchive, handleDelete }) {
  const [search, setSearch] = useState("");
  const [sortedData, setSortedData] = useState(data);
  const [sortBy, setSortBy] = useState(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [bareme, setBareme] = useState(0);
  const navigation = useNavigate();
  const [editBaremeEpreuve] = useEditEpreuvesMutation();
  const dispatch = useDispatch();
  
  const setSorting = useCallback((field) => {
    const reversed = field === sortBy ? !reverseSortDirection : false;
    setReverseSortDirection(reversed);
    setSortBy(field);
    setSortedData(sortData(data, { sortBy: field, reversed, search }));
  }, [sortBy, reverseSortDirection, data, search]);

  useMemo(() => {
    setSortedData(data);
  }, [data]);

  const rows = sortedData?.map((row) => (
    <tr key={row?.id}>
      <td>
        <Text weight={600}>
          {row?.diagnostic} ({row?.diagnosticId?.type_diagnostique})
        </Text>
      </td>
      <td>
        <Group noWrap>
          <Text weight={600}>
            {row?.titre}
          </Text>
        </Group>
      </td>
      <td>
        <Group noWrap>
          <Text weight={600}>
            {row?.niveauId?.name}
          </Text>
        </Group>
      </td>
      <td>
        <Group spacing="xs">
          {editItem && editItem === row.id ? (
            <>
              <TextInput
                size="xs"
                radius={20}
                w={70}
                type="number"
                value={bareme}
                onChange={(e) => setBareme(e.target.value)}
              />
              <ActionIcon
                color="green"
                onClick={async () => {
                  try {
                    const body = {
                      id: row.id,
                      bareme: bareme,
                    };
                    const res = await editBaremeEpreuve({ body });
                    toast.success("Modification bareme reussie");
                    setEditItem(null);
                  } catch (error) {
                    toast.error("edit bareme erreur");
                    console.log("edit bareme erreur ", error);
                  }
                }}
              >
                <Check size={18} />
              </ActionIcon>
            </>
          ) : (
            <>
              <Badge>{row?.bareme}</Badge>
              <ActionIcon
                color="green"
                onClick={() => {
                  setEditItem(row?.id);
                  setBareme(parseInt(row.bareme));
                }}
              >
                <Edit size={18} />
              </ActionIcon>
            </>
          )}
        </Group>
      </td>
      <td>
        <Switch
          style={{ cursor: "pointer" }}
          checked={row?.archived}
          onChange={() => handleArchive(row.id, row.archived)}
        />
      </td>
      <td>
        <Group spacing="xs" position="right">
          <ActionIcon
            color="blue"
            onClick={() =>
              navigation(`details epreuve`, {
                state: { title: row.title, id: row.id },
              })
            }
          >
            <Eye size={18} />
          </ActionIcon>
          <ActionIcon color="red" onClick={() => handleDelete(row.id)}>
            <Trash size={18} />
          </ActionIcon>
        </Group>
      </td>
    </tr>
  ));

  return (
    <ScrollArea>
      <Table
        horizontalSpacing="md"
        verticalSpacing="xs"
        miw={700}
        sx={{ tableLayout: "fixed" }}
        bg={"#fff"}
        mb={30}
      >
        <thead>
          <tr>
            <Th
              sorted={sortBy === "diagnostic"}
              reversed={reverseSortDirection}
              onSort={() => setSorting("diagnostic")}
            >
              Diagnostic
            </Th>
            <Th
              sorted={sortBy === "titre"}
              reversed={reverseSortDirection}
              onSort={() => setSorting("titre")}
            >
              Exercie
            </Th>
            <Th
              sorted={sortBy === "niveau"}
              reversed={reverseSortDirection}
              onSort={() => setSorting("niveau")}
            >
              Niveau
            </Th>
            <Th
              sorted={sortBy === "bareme"}
              reversed={reverseSortDirection}
              onSort={() => setSorting("bareme")}
            >
              Bareme
            </Th>
            <Th
              sorted={sortBy === "archived"}
              reversed={reverseSortDirection}
              onSort={() => setSorting("archived")}
            >
              Archive
            </Th>
            <th style={{ textAlign: "right" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {rows?.length > 0 ? (
            rows
          ) : (
            <tr>
              <td colSpan={6}>
                <Text weight={500} align="center">
                  Pas de données
                </Text>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </ScrollArea>
  );
}